
import * as Weirwood from '@baidu/weirwood-sdk';
import wirewoodOption from './weirwood.json';

const options = {
    common: {
        buildid: wirewoodOption.buildid,
        token: wirewoodOption.token,
        ignoreUrls: [
            // 本地开发屏蔽错误发送
            'localhost',
            '127.0.0.1',
            'http://zhanglei.rl_doc_beta.dev.weiyun.baidu.com:8081/',
            'https://toc.dev.weiyun.baidu.com',
        ],
    },
    error: {
        collectWindowErrors: true,
        collectUnhandledRejections: true,
        collectResourceLoadErrors: true,
        ignoreUrls: [
            // 本地开发屏蔽错误发送，请按需修改
            'localhost',
            '127.0.0.1',
            'http://zhanglei.rl_doc_beta.dev.weiyun.baidu.com:8081/',
            'https://toc.dev.weiyun.baidu.com',
        ],
        ignoreApiUrls: [
            '/wiki/ku/message/category/statistics',
            /ku\/sheet\/\w{14}\/collaborators/,
        ],
    },
    perf: {
        // weirwood中的项目稳定性做的页面前端异常率的计算公式，总PV是性能PV，如果禁用性能监控，会导致项目稳定性不可用
        // 禁用性能监控
        disable: true, // 性能日志使用场景低但开销大，20250311暂时禁用，后续观察效果，再决定是否启用，或者调整采样率进行优化
        // 性能数据PV日志会比较大，可以输入 sampleRate 进行采样，控制在 50 W左右
        sampleRate: 0.25,
        spa: true,
        history: true,
        ignoreXhrs: [
            '/wiki/ku/message/category/statistics',
            /ku\/sheet\/\w{14}\/collaborators/,
        ],
    },
};

let weirwood: any = null;
try {
    if (!(window as any).isSharePage) {
        weirwood = Weirwood.init(options);
    }
} catch (e) {
    console.log('e: ', e);
}

export default weirwood;
